import { useState } from "react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faEye, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import ValoresTable from "./components/ValoresTable";
import ValoresForm from "./components/ValoresForm";
import TarifasForm from "./components/TarifasForm";
import { fetchTarifas } from "../../../../../../redux/tarifas";
import { API_TARIFAS, API_TARIFAS_VALORES } from "../../../shared/services/tarifas";
import { toast } from "react-toastify";
import ConfirmModal from "../../../shared/components/ConfirmModal";
import InfoModal from "../../../shared/components/InfoModal";

export default function Tarifas() {
    const dispatch = useDispatch();
    const [tarifaId, setTarifaId] = useState(null);
    const [currentTarifa, setCurrentTarifa] = useState(null);
    const [currentValor, setCurrentValor] = useState(null);
    const [isViewValores, setIsViewValores] = useState(false);
    const [isEditTarifa, setIsEditTarifa] = useState(false);
    const [isNewTarifa, setIsNewTarifa] = useState(false);
    const [isEditValor, setIsEditValor] = useState(false);
    const [isNewValor, setIsNewValor] = useState(false);
    const [isForDelete, setIsForDelete] = useState(false);
    const tarifas = useSelector(state => {
        return state.tarifas
    });
    const tipoClientes = useSelector(state => {
        const { tipo_clientes } = state;
        return tipo_clientes;
    });

    const viewValores = (tarifa) => {
        setTarifaId(tarifa.id);
        setIsViewValores(true);
    }

    const handleEditElement = (element, elementValue) => {
        if(element === 'tarifa') {
            setCurrentTarifa(elementValue);
            setIsEditTarifa(true);
        } else {
            setIsEditValor(true);
            const valor = tarifas.find(t => t.id === tarifaId).valores.find(v => v.id === elementValue);
            setCurrentValor(valor);
        }
    }

    const handleCancelElement = (element) => { 
        if(element === 'tarifa') {
            if(isEditTarifa) setIsEditTarifa(false); 
            else setIsNewTarifa(false);
    
            setCurrentTarifa(null);
        } else {
            if(isEditValor) setIsEditValor(false); 
            else setIsNewValor(false);
    
            setCurrentValor(null);
        }
    }

    const newElement = (element) => {
        if(element === 'tarifa') {
            setIsEditTarifa(false);
            setIsNewTarifa(true);
        } else {
            setIsEditValor(false); 
            setIsNewValor(true);
        }
    }

    const handleActionDone = () => {
        dispatch(fetchTarifas());
        setIsNewTarifa(false);
        setIsNewValor(false);
        setIsEditTarifa(false);
        setIsEditValor(false);
    }

    const handleDeleteElement = async(element, elementId) => {
        let response;
        dispatch({type: 'loading/set', payload: true});

        if(element === 'tarifa') {
            response = await API_TARIFAS.deleteTarifa(elementId);
            setTarifaId(null);
            setCurrentTarifa(null);
        } else {
            response = await API_TARIFAS_VALORES.deleteTarifaValor(elementId);
            setCurrentValor(null);
        }

        if(response && response.success) {
            dispatch({type: 'loading/set', payload: false});
            toast.success(response.message);
            dispatch(fetchTarifas());
        }
    }

    const handleDeleteTarifa = (id) => { 
        setTarifaId(id);
        setIsViewValores(false);
        setIsForDelete(true); 
    }

    const handleConfirmDelete = (confirm) => {
        if(confirm) {
            handleDeleteElement('tarifa', tarifaId)
        } else setIsForDelete(false);
    }

    const handleCloseTarifa = () => { 
        setCurrentTarifa(null); 
        setIsNewTarifa(false); 
        setIsEditTarifa(false); 
        setTarifaId(null);
    }

    const handleCloseValor = () => {
        setCurrentValor(null);
        setIsNewValor(false);
        setIsEditValor(false);
    }

    return (
        <div className="w-100 d-flex flex-wrap flex-md-nowrap">
            <div className="col-12 col-md-6 d-flex flex-column align-items-end pe-0 pe-md-4">
                <button className="btn btn-add ms-0 ms-md-5" onClick={() => newElement('tarifa')}>
                    <span className="add">
                        <FontAwesomeIcon icon={faPlus} size="1x" className="action" color="#215732" />
                    </span>
                    Nueva
                </button>

                <div className="w-100 d-flex flex-column mt-4">
                    { tarifas.map(tarifa => {
                        return (
                            <div className="w-100 d-flex flex-column" key={'tarifa-' + tarifa.id}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <p className="m-0 text-uppercase">{tarifaId === tarifa.id ? <b>{tarifa.nombre}</b> : tarifa.nombre} - {tipoClientes.find(f => f.id === tarifa.tipo_cliente_id)?.nombre}</p>
                                    <div>
                                        {tarifa.default ? <span className="default me-3">POR DEFECTO</span> : ''}
                                        <span title="Ver valores" style={{cursor: 'pointer'}} className="me-3">
                                            <FontAwesomeIcon icon={faEye} size="1x" className="action" color="#215732" onClick={() => viewValores(tarifa)} />
                                        </span>
                                        <span title="Editar" style={{cursor: 'pointer'}} className="me-3">
                                            <FontAwesomeIcon icon={faPen} size="1x" className="action" color="#215732" onClick={() => handleEditElement('tarifa', tarifa)} />
                                        </span>
                                        <span title="Eliminar" style={{cursor: 'pointer'}}>
                                            <FontAwesomeIcon icon={faTrash} size="1x" className="action" color="#dc3545" onClick={() => handleDeleteTarifa(tarifa.id)} />
                                        </span>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        )
                    }) }
                </div>
            </div>

            <div className="col-12 col-md-6 d-flex flex-column align-items-end ps-0 ps-md-4 mt-5 mt-md-0">
                <button type="button" className="btn btn-add" onClick={() => newElement('valor')}>
                    <span className="add">
                        <FontAwesomeIcon icon={faPlus} size="1x" className="action" color="#215732" />
                    </span>
                    Nuevo
                </button>
                
                <div className="w-100 d-flex flex-column mt-4">
                    { (tarifaId && isViewValores) &&
                        <ValoresTable 
                            valores={tarifas.find(t => t.id === tarifaId)?.valores}
                            onEdit={handleEditElement}
                            onDelete={handleDeleteElement}
                        />
                    }
                </div>
            </div>

            { (isEditTarifa || isNewTarifa) && 
                <InfoModal
                    state={isEditTarifa || isNewTarifa}
                    title={(isEditTarifa ? 'Editar' : 'Nueva') + ' tarifa'}
                    content={
                        <TarifasForm 
                            tarifa={currentTarifa}
                            isEdit={isEditTarifa}
                            onActionDone={handleActionDone}
                            onCancel={handleCancelElement}
                        />
                    }
                    width={'sm'}
                    onClose={handleCloseTarifa}
                ></InfoModal>
            }

            { (isEditValor || isNewValor) && 
                <InfoModal
                    state={isEditValor || isNewValor}
                    title={(isEditValor ? 'Editar' : 'Nuevo') + ' valor'}
                    content={
                        <ValoresForm 
                            valor={currentValor} 
                            tarifaId={tarifaId}
                            isEdit={isEditValor}
                            onActionDone={handleActionDone}
                            onCancel={handleCancelElement}
                        />
                    }
                    width={'sm'}
                    onClose={handleCloseValor}
                ></InfoModal>
            }

            { isForDelete && 
                <ConfirmModal 
                    onConfirmAction={handleConfirmDelete} 
                    title={'Eliminar'} 
                    description={'Estás seguro de eliminar?'}
                    state={isForDelete}>
                </ConfirmModal>
            }
        </div>
    )
}